import { toastController } from "@ionic/vue";

let isToastShown = false;
const toastDuration = 3000;

export async function showSuccessToast(successMessage: string): Promise<void> {
  if (isToastShown) {
    return
  } else {
    isToastShown = true;
    const toast = await toastController
      .create({
        message: successMessage,
        position: 'bottom',
        duration: toastDuration,
        color: 'success',
      })

    toast.present();

    await toast.onDidDismiss()
    isToastShown = false;
  }
}

export async function showErrorToast(errorMessage: string): Promise<void> {
  if (isToastShown) {
    return
  } else {
    isToastShown = true;
    const toast = await toastController
      .create({
        header: 'Error',
        message: errorMessage,
        position: 'bottom',
        duration: toastDuration,
        color: 'danger',
      })

    toast.present();

    await toast.onDidDismiss()
    isToastShown = false;
  }
}

export async function showInfoToast(infoMessage: string): Promise<void> {
  if (isToastShown) {
    return
  } else {
    isToastShown = true;
    const toast = await toastController
      .create({
        message: infoMessage,
        position: 'bottom',
        duration: toastDuration,
      })

    toast.present();

    await toast.onDidDismiss()
    isToastShown = false;
  }
}

export function showGenericErrorToast(): Promise<void> {
  return showErrorToast('Unexpected error occurred. Contact technical support for further assistance should this error continue.');
}
